import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9d60fd56")

_pushScopeId("data-v-9d60fd56")
const _hoisted_1 = { class: "dt-open-api-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_home_header = _resolveComponent("home-header")
  const _component_router_view = _resolveComponent("router-view")
  const _component_version_update = _resolveComponent("version-update")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_home_header),
    _createVNode(_component_router_view),
    _createVNode(_component_version_update)
  ]))
})